import _ from "lodash";

import * as addLegalDocument from '@/api/crm/legalDocuments/addLegalDocument';
import * as updateLegalDocument from '@/api/crm/legalDocuments/updateLegalDocument';
import * as deleteLegalDocument from '@/api/crm/legalDocuments/deleteLegalDocument';
import * as getLegalDocuments from '@/api/crm/legalDocuments/getLegalDocuments.js';

import * as deleteDataController from '@/api/crm/legalDocuments/deleteDataController';
import * as addDataController from '@/api/crm/legalDocuments/addDataController';
import * as getDataControllers from '@/api/crm/legalDocuments/getDataControllers.js';

import * as getDataProcessor from '@/api/crm/legalDocuments/getDataProcessor.js';
import * as updateDataProcessor from '@/api/crm/legalDocuments/updateDataProcessor.js';


export default {
    namespaced: true,
    state: {
        documents: [],
        controllers: [],
        dataProcessor: null,
        languages: [{
            name: "Danish",
            value: "DANISH"
        },
        {
            name: "Norwegian",
            value: "NORWEGIAN"
        },
        {
            name: "Finnish",
            value: "FINNISH"
        },
        {
            name: "English",
            value: "ENGLISH"
        }],
        countries: [{
            name: "Denmark",
            value: "DENMARK"
        },
        {
            name: "Norway",
            value: "NORWAY"
        },
        {
            name: "Finland",
            value: "FINLAND"
        },
        {
            name: "United Kingdom",
            value: "UNITED_KINGDOM"
        }],

    },
    mutations: {
        gotDocuments(state, result) {
            console.log("Got legal documents", result);
            state.documents = result;
        },
        gotControllers(state, result) {
            console.log("Got data controllers", result);
            state.controllers = result;
        },
        gotDataProcessor(state, result) {
            state.dataProcessor = result;
        },
    },
    actions: {
        async getAllControllers({ commit, getters }, force = true) {
            if (!force && getters.controllers.length > 0) return;
            const result = await getDataControllers.get();
            if (result) commit("gotControllers", result);
        },
        async createController({ dispatch }, dto) {
            await addDataController.post(dto);
            await dispatch("getAllControllers")
        },
        async getAll({ commit, getters }, force = true) {
            if (!force && getters.documents.length > 0) return;
            const result = await getLegalDocuments.get();
            if (result) commit("gotDocuments", result);
        },
        async create({ dispatch }, dto) {
            await addLegalDocument.post(dto);
            await dispatch("getAll")
        },
        async update({ dispatch }, dto) {
            await updateLegalDocument.put(dto);
            await dispatch("getAll")
        },
        async delete({ dispatch }, id) {
            await deleteLegalDocument.del(id);
            await dispatch("getAll")
        },
        async deleteController({ dispatch }, id) {
            //console.log("Deleting", id);
            await deleteDataController.del(id);
            await dispatch("getAllControllers")
        },
        async getDataProcessor({ commit }) {
            const result = await getDataProcessor.get();
            if (result) commit("gotDataProcessor", result);
        },
        async updateDataProcessor({ dispatch }, dto) {
            await updateDataProcessor.put(dto);
            await dispatch("getDataProcessor")
        },
    },
    getters: {
        document: state => (id) => state.documents.find(e => e.id === id),
        documents: state => state.documents,
        controller: state => (id) => state.controllers.find(e => e.id === id),
        controllers: state => state.controllers,
        countries: state => state.countries,
        languages: state => state.languages,
        dataProcessor: state => state.dataProcessor
    }
};
